import PropTypes from 'prop-types'
import React from 'react'

export function HeaderRow(props) {
  const {headerOptions} = props
  return headerOptions.map((option, index) => (
    <th key={option.displayName + '_' + index}>
      <div className="table__headname">{option.displayName}</div>
    </th>
  ))
}

HeaderRow.propTypes = {
  headerOptions: PropTypes.array,
}
